import type { MenuItem } from '@/types';

export type ConsumerMode = 'takeaway' | 'delivery' | 'dine_in';

export function modeToPriceType(mode: ConsumerMode): 'emporter' | 'livraison' | 'sur_place' {
  return mode === 'delivery' ? 'livraison' : mode === 'dine_in' ? 'sur_place' : 'emporter';
}

export function resolveModePrice(item: MenuItem, mode: ConsumerMode): number {
  return item.pricesByMode?.[modeToPriceType(mode)] ?? item.price;
}
